import { render } from "./saveCategorieProduit.vue?vue&type=template&id=1c474b3a&scoped=true"
import script from "./saveCategorieProduit.vue?vue&type=script&lang=js"
export * from "./saveCategorieProduit.vue?vue&type=script&lang=js"

import "./saveCategorieProduit.vue?vue&type=style&index=0&id=1c474b3a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c474b3a"]])

export default __exports__